import request from '@/utils/request'

let Tuiguang_mubiaoApi = {

  /*推广目标列表*/
  list(data) {
    return request._post('/shop/plus.tuiguang_mubiao.Index/index', data);
},
/*添加推广目标*/
add(data) {
    return request._post('/shop/plus.tuiguang_mubiao.Index/add', data);
},
/*修改推广目标*/
edit(data) {
    return request._post('/shop/plus.tuiguang_mubiao.Index/edit', data);
},
/*删除推广目标*/
del(data) {
    return request._post('/shop/plus.tuiguang_mubiao.Index/del', data);
},
/*推广目标详情*/
detail(data) {
  return request._post('/shop/plus.tuiguang_mubiao.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.tuiguang_mubiao.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.tuiguang_mubiao.Setting/getSetting', data, errorback);
    },
}
export default Tuiguang_mubiaoApi;



// WEBPACK FOOTER //
// ./src/api/tuiguang_mubiao.js